import { useState, useCallback } from 'react';
export function useSelectMilestone(milestones) {
  var _milestones$find;
  const [selectedMilestoneId, setSelectedMilestoneId] = useState(null);
  const selectedMilestone = (_milestones$find = milestones.find(m => m.milestoneId === selectedMilestoneId)) !== null && _milestones$find !== void 0 ? _milestones$find : null;
  const onToggleMilestoneSidebar = useCallback(milestoneId => {
    setSelectedMilestoneId(m => m === milestoneId ? null : milestoneId);
  }, []);
  const onCloseMilestoneSidebar = useCallback(() => {
    setSelectedMilestoneId(null);
  }, []);
  return {
    selectedMilestoneId,
    selectedMilestone,
    onToggleMilestoneSidebar,
    onCloseMilestoneSidebar
  };
}